import UpdateHandlers from '../../../types/updateHandlers.type';
import useHandleAddDiscount from './handlers/useHandleAddDiscount';
import useHandleAddManualItem from './handlers/useHandleAddManualItem';
import useHandleAddTile from './handlers/useHandleAddTile';
import useHandleAssignCustomer from './handlers/useHandleAssignCustomer';
import useHandleCashPayment from './handlers/useHandleCashPayment';
import useHandleCheckGiftCardBalance from './handlers/useHandleCheckGiftCardBalance';
import useHandleExternalTerminalPayment from './handlers/useHandleExternalTerminalPayment';
import useHandleRePrintReceipt from './handlers/useHandleRePrintReceipt';
import useHandleSendAQuote from './handlers/useHandleSendAQuote';
import useHandleShipToCustomer from './handlers/useHandleShipToCustomer';
import useHandleStartReturn from './handlers/useHandleStartReturn';

type Args = {
  updateDialogStates: UpdateHandlers<unknown>;
};

const useTileActionHandler = ({ updateDialogStates }: Args) => {
  const startReturnHandlers = useHandleStartReturn();
  const shipToCustomerHandlers = useHandleShipToCustomer(updateDialogStates);
  const addDiscountHandlers = useHandleAddDiscount(updateDialogStates);
  const addManualItemHandlers = useHandleAddManualItem();
  const checkGiftCardBalanceHandlers = useHandleCheckGiftCardBalance();
  const rePrintReceiptHandlers = useHandleRePrintReceipt();
  const sendAQuoteHandlers = useHandleSendAQuote();
  const assignCustomerHandlers = useHandleAssignCustomer(updateDialogStates);
  const addTile = useHandleAddTile(updateDialogStates);
  const cashPaymentHandlers = useHandleCashPayment(updateDialogStates);
  const externalTerminalPaymentHandlers =
    useHandleExternalTerminalPayment(updateDialogStates);

  const tileActionHandlers = {
    ['start-return']: startReturnHandlers,
    ['ship-to-customer']: shipToCustomerHandlers,
    ['add-discount']: addDiscountHandlers,
    ['add-manual-item']: addManualItemHandlers,
    ['check-gift-card-balance']: checkGiftCardBalanceHandlers,
    ['re-print-receipt']: rePrintReceiptHandlers,
    ['send-a-quote']: sendAQuoteHandlers,
    ['assign-customer']: assignCustomerHandlers,
    ['add-tile']: addTile,
    ['payment-cash']: cashPaymentHandlers,
    ['payment-external-terminal']: externalTerminalPaymentHandlers,
  };

  return {
    tileActionHandlers,
  };
};

export default useTileActionHandler;
